type AdsEnv = Record<string, string | undefined>

function firstNonEmpty(...values: Array<string | undefined>): string | undefined {
  for (const value of values) {
    const trimmed = value?.trim()
    if (trimmed) return trimmed
  }
  return undefined
}

function normalizeSendTo(googleAdsId: string | undefined, conversionValue: string | undefined): string | undefined {
  const value = conversionValue?.trim()
  if (!value) return undefined
  if (value.startsWith('AW-')) return value
  if (!googleAdsId) return undefined
  return `${googleAdsId}/${value}`
}

function deriveGoogleAdsId(...values: Array<string | undefined>): string | undefined {
  for (const value of values) {
    const match = value?.trim().match(/^(AW-\d+)/)
    if (match) return match[1]
  }
  return undefined
}

export function getGoogleAdsConfig(env: AdsEnv = import.meta.env): {
  googleAdsId?: string
  signupSendTo?: string
  purchaseSendTo?: string
} {
  const signupValue = firstNonEmpty(
    env.VITE_GOOGLE_ADS_CONVERSION_SIGNUP,
    env.NEXT_PUBLIC_GOOGLE_ADS_CONVERSION_SIGNUP,
  )
  const purchaseValue = firstNonEmpty(
    env.VITE_GOOGLE_ADS_CONVERSION_PURCHASE,
    env.NEXT_PUBLIC_GOOGLE_ADS_CONVERSION_PURCHASE,
  )

  const googleAdsId = firstNonEmpty(
    env.VITE_GOOGLE_ADS_ID,
    env.NEXT_PUBLIC_GOOGLE_ADS_ID,
    deriveGoogleAdsId(signupValue, purchaseValue),
  )

  return {
    googleAdsId,
    signupSendTo: normalizeSendTo(googleAdsId, signupValue),
    purchaseSendTo: normalizeSendTo(googleAdsId, purchaseValue),
  }
}
